import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import ReactGPicker from './gcolor';
import { DropdownMenu } from '../../ui/DropDown/DropdownMenu';
import { DropdownMenuTrigger } from '../../ui/DropDown/DropdownMenuTrigger';
import Label from '../../ui/Label';
import { DropdownMenuContent } from '../../ui/DropDown/DropdownMenuContent';
import { gerarTema, type Tema } from '../../lib/tema';

interface ColorPickerProps {
	placeholder: string;
	color: string;
	onChange?: (cor: string, tema?: Tema) => void;
	side?: 'bottom' | 'left' | 'right' | 'top' | undefined;
	sideOffset?: number;
	gradient?: boolean;
	align?: 'center' | 'start' | 'end' | undefined;
	theme?: boolean;
}

const ColorPicker = ({ placeholder, color, onChange, side, sideOffset, gradient, align, theme }: ColorPickerProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [colorHex, setColorHex] = useState(color);

	useEffect(() => {
		setColorHex(color);
	}, [color]);

	const handleColorChange = (cor: string) => {
		setColorHex(cor);
		onChange?.(cor, theme ? gerarTema(cor) : undefined);
	};

	const backgroundStyle = colorHex.match(/gradient/)
		? { backgroundImage: colorHex }
		: { backgroundColor: colorHex };

	return (
		<DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen}>
			<DropdownMenuTrigger>
				<Label>
					<div className={twMerge(`!flex !items-center text-gray-900 font-sans text-sm font-medium leading-5 tracking-normal !justify-between !bg-white hover:!bg-gray-50 !px-2 !py-1.5 !rounded-md !select-none !cursor-pointer !outline-none ${isOpen ? 'bg-gray-50' : ''}`)}>
						{placeholder}

						<div className='bg-gray-200 border border-gray-200 size-6 rounded-full' style={backgroundStyle}></div>
					</div>
				</Label>
			</DropdownMenuTrigger>
			<DropdownMenuContent align={align} sideOffset={sideOffset || 0} side={side} className='bg-transparent border-0'>
				<ReactGPicker gradient={gradient} debounceMS={1} solid value={colorHex} onChange={(e) => handleColorChange(e)} />
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default ColorPicker;
